import React from 'react';
import { Phone, MessageCircle, GraduationCap } from 'lucide-react';

/**
 * Sticky mobile bottom CTA bar - shows on small screens only.
 * Pinned to viewport, gives 3 quick conversion actions.
 */
const MobileStickyCTA = ({ onEligibilityClick }) => {
  return (
    <div
      data-testid="mobile-sticky-cta"
      className="lg:hidden fixed bottom-0 left-0 right-0 z-40 bg-white/95 backdrop-blur-md border-t border-gray-200 shadow-[0_-8px_24px_rgba(0,0,0,0.08)] safe-bottom"
    >
      <div className="grid grid-cols-3 divide-x divide-gray-200">
        <a
          href="tel:+917594881898"
          className="flex flex-col items-center justify-center py-2.5 text-[11px] font-semibold text-[#2B5B8A] hover:bg-[#F0F8FF] transition-colors"
          data-testid="mobile-cta-call"
        >
          <Phone size={18} className="mb-0.5" />
          Call
        </a>
        <a
          href="https://wa.me/917558881898?text=Hi%20Patrick%27s%20Edu%20Care%2C%20I%27d%20like%20to%20know%20more%20about%20studying%20abroad."
          target="_blank"
          rel="noopener noreferrer"
          className="flex flex-col items-center justify-center py-2.5 text-[11px] font-semibold text-[#25D366] hover:bg-green-50 transition-colors"
          data-testid="mobile-cta-whatsapp"
        >
          <MessageCircle size={18} className="mb-0.5" />
          WhatsApp
        </a>
        <button
          onClick={onEligibilityClick}
          className="flex flex-col items-center justify-center py-2.5 text-[11px] font-semibold text-white bg-gradient-to-r from-[#2B5B8A] to-[#4DD4AC] hover:opacity-95 transition-opacity"
          data-testid="mobile-cta-eligibility"
        >
          <GraduationCap size={18} className="mb-0.5" />
          Check Eligibility
        </button>
      </div>
    </div>
  );
};

export default MobileStickyCTA;
